/**
 * HESTIA cart engine
 * - Fast ATC drawer open
 * - Trash removes ONE deal (paid stick + free stick + bag + mystery), not the whole cart
 * - Orphan gifts never linger (deal-group: remove powder → powders + bag + mystery)
 * - Gift-only $0 carts force-purged; checkout blocked until primary deal present
 */
(function () {
  // Store-specific B1G3 IDs. Prefer window.hestiaCartConfig (set in layout) when present.
  var cfg = window.hestiaCartConfig || {};
  var HESTIA_PRODUCT_ID = Number(cfg.hestiaProductId) || 15435057496152;
  var HAIRLINE_PRODUCT_ID = Number(cfg.hairlineProductId) || 15484285157464;
  var GIFT_PRODUCT_IDS = Object.assign(
    { bag: 15442060705880, mystery: 15421012344920 },
    cfg.giftProductIds || {}
  );
  var GIFT_VARIANT_IDS = Object.assign(
    { bag: 67799775117400, mystery: 67667762380888 },
    cfg.giftVariantIds || {}
  );
  // Every gift variant that must never checkout alone (Beige + Pink + legacy travel bag)
  var ALL_BAG_VARIANT_IDS = (cfg.allBagVariantIds && cfg.allBagVariantIds.length)
    ? cfg.allBagVariantIds.map(Number)
    : [67799775117400, 67799775084632, 67755739840600, 67755739873368];
  var LEGACY_BAG_PRODUCT_IDS = (cfg.legacyBagProductIds && cfg.legacyBagProductIds.length)
    ? cfg.legacyBagProductIds.map(Number)
    : [15437535084632];
  var LEGACY_MYSTERY_PRODUCT_IDS = (cfg.legacyMysteryProductIds && cfg.legacyMysteryProductIds.length)
    ? cfg.legacyMysteryProductIds.map(Number)
    : [15424148635736];
  var ALL_GIFT_VARIANT_IDS = ALL_BAG_VARIANT_IDS.concat([GIFT_VARIANT_IDS.mystery]);
  var ALL_GIFT_PRODUCT_IDS = [GIFT_PRODUCT_IDS.bag, GIFT_PRODUCT_IDS.mystery]
    .concat(LEGACY_BAG_PRODUCT_IDS)
    .concat(LEGACY_MYSTERY_PRODUCT_IDS);

  var syncing = false;
  var claiming = false;
  var removingBundle = false;
  var lastOpenAt = 0;
  var lastCart = null;
  var refreshTimer = null;

  var pageScrollLocked = false;
  var touchGuardBound = false;
  var savedScrollY = 0;
  var drawerMoBound = false;

  function clearLockClasses() {
    document.documentElement.classList.remove('hestia-cart-open', 'hestia-scroll-locked', 'overflow-hidden');
    document.body.classList.remove('hestia-cart-open', 'overflow-hidden', 'hestia-scroll-locked-fixed');
    document.body.style.top = '';
    document.body.style.pointerEvents = '';
    document.documentElement.style.pointerEvents = '';
    pageScrollLocked = false;
  }

  // True while CartDrawer.open() is mid-way (openDrawer set, .active not yet added).
  function drawerIsOpening(d) {
    return !!(d && d.openDrawer && !d._hestiaClosing && !d.classList.contains('active'));
  }

  // Only touch the class attribute when a class is actually present. classList.remove()
  // rewrites the attribute even when nothing changes, which re-fires every class
  // MutationObserver on the drawer — that caused an infinite loop that froze the page.
  function removeDrawerClasses(d) {
    if (!d) return;
    ['animate', 'cart-drawer--editor-open'].forEach(function (c) {
      if (d.classList.contains(c)) d.classList.remove(c);
    });
  }

  function stripDrawerCatcher() {
    var d = getDrawer();
    if (d && !d.classList.contains('active') && !drawerIsOpening(d)) removeDrawerClasses(d);
  }

  function lockPageScroll() {
    var y = window.scrollY || window.pageYOffset || 0;
    if (!pageScrollLocked) {
      savedScrollY = y;
      document.documentElement.dataset.hestiaScrollY = String(y);
    } else {
      y = parseInt(document.documentElement.dataset.hestiaScrollY || String(savedScrollY) || '0', 10) || y;
    }
    document.documentElement.classList.add('hestia-cart-open', 'hestia-scroll-locked', 'overflow-hidden');
    document.body.classList.add('hestia-cart-open', 'overflow-hidden', 'hestia-scroll-locked-fixed');
    document.body.style.top = '-' + y + 'px';
    pageScrollLocked = true;
    bindTouchScrollGuard();
  }

  function unlockPageScroll() {
    var y = parseInt(document.documentElement.dataset.hestiaScrollY || String(savedScrollY) || '0', 10) || 0;
    stripDrawerCatcher();
    clearLockClasses();
    unbindTouchScrollGuard();
    delete document.documentElement.dataset.hestiaScrollY;
    try { window.scrollTo(0, y); } catch (err) {}
  }
  window.__hestiaUnlockPageScroll = unlockPageScroll;

  function ensureInteractiveIfDrawerClosed() {
    var d = getDrawer();
    if (d && d.classList.contains('active')) return;
    if (drawerIsOpening(d)) return; // don't sabotage an open that's in progress
    var hadAnimate = false;
    if (d) {
      hadAnimate = d.classList.contains('animate') || d.classList.contains('cart-drawer--editor-open');
      if (hadAnimate) removeDrawerClasses(d);
    }
    var stuck =
      pageScrollLocked ||
      touchGuardBound ||
      document.documentElement.classList.contains('hestia-scroll-locked') ||
      document.documentElement.classList.contains('hestia-cart-open') ||
      document.body.classList.contains('hestia-scroll-locked-fixed') ||
      document.body.classList.contains('hestia-cart-open') ||
      !!document.body.style.top;
    if (stuck || hadAnimate) unlockPageScroll();
  }

  function bindDrawerGhostObserver() {
    if (drawerMoBound) return;
    var d = getDrawer();
    if (!d || typeof MutationObserver === 'undefined') return;
    drawerMoBound = true;
    var wasActive = d.classList.contains('active');
    var mo = new MutationObserver(function () {
      var isActive = d.classList.contains('active');
      if (wasActive && !isActive) {
        removeDrawerClasses(d);
        unlockPageScroll();
      }
      wasActive = isActive;
    });
    mo.observe(d, { attributes: true, attributeFilter: ['class'] });
  }

  function isInsideCartItemsScroller(target) {
    if (!target || !target.closest) return false;
    return !!target.closest('cart-drawer-items');
  }

  function onCartTouchMove(e) {
    if (!pageScrollLocked) return;
    if (isInsideCartItemsScroller(e.target)) return;
    if (e.cancelable) e.preventDefault();
  }

  function bindTouchScrollGuard() {
    if (touchGuardBound) return;
    touchGuardBound = true;
    document.addEventListener('touchmove', onCartTouchMove, { passive: false, capture: true });
    document.addEventListener('wheel', onCartTouchMove, { passive: false, capture: true });
  }

  function unbindTouchScrollGuard() {
    if (!touchGuardBound) return;
    document.removeEventListener('touchmove', onCartTouchMove, true);
    document.removeEventListener('wheel', onCartTouchMove, true);
    touchGuardBound = false;
  }


  function routesRoot() {
    try {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    } catch (e) {
      return '/';
    }
  }

  function cartUrl(path) {
    return routesRoot().replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function openDrawer() {
    var d = getDrawer();
    if (!d) return;
    var now = Date.now();
    // Debounce only when already open — still allow first open to animate.
    if (now - lastOpenAt < 250 && d.classList.contains('active')) return;
    lastOpenAt = now;
    lockPageScroll();

    // Prefer theme CartDrawer.open() (setTimeout before active) for native slide.
    if (typeof d.open === 'function') {
      try {
        // Ensure we start from the closed transform so the transition can run.
        if (!d.classList.contains('active')) {
          d.classList.remove('active');
          d.classList.add('animate');
        }
        var yKeep = window.scrollY || window.pageYOffset || 0;
        d.open(null, { lockScroll: true, shouldTrapFocus: true });
        try { window.scrollTo(0, yKeep); } catch (e1) {}
        return;
      } catch (err) {}
    }

    // Fallback: paint off-screen (animate, not active), then slide in on next frames.
    d.classList.remove('active');
    d.classList.add('animate');
    // Force layout so translate3d(100%) is committed before .active
    void d.offsetWidth;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        d.classList.add('active');
      });
    });
  }

  function closeDrawer() {
    var d = getDrawer();
    if (d) {
      d.openDrawer = false;
      d._hestiaClosing = true;
    }
    if (d && typeof d.close === 'function') {
      try { d.close(); } catch (err) {}
    }
    if (d) d.classList.remove('active', 'animate', 'cart-drawer--editor-open');
    unlockPageScroll();
    if (d) setTimeout(function () { d._hestiaClosing = false; }, 500);
  }

  var fetchCartInflight = null;
  var fetchCartAt = 0;
  function fetchCart(force) {
    var now = Date.now();
    if (!force && fetchCartInflight && now - fetchCartAt < 400) return fetchCartInflight;
    fetchCartAt = now;
    fetchCartInflight = fetch(cartUrl('cart.js'), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json', 'X-Hestia-Cart': '1' }
    }).then(function (r) {
      return r.json();
    }).then(function (cart) {
      lastCart = cart;
      return cart;
    }).finally(function () {
      setTimeout(function () { fetchCartInflight = null; }, 50);
    });
    return fetchCartInflight;
  }

  function getSections() {
    var d = getDrawer();
    if (d && typeof d.getSectionsToRender === 'function') {
      try {
        return d.getSectionsToRender().map(function (s) {
          return s.id;
        });
      } catch (e) {}
    }
    return ['cart-drawer-theme-blocks', 'cart-icon-bubble'];
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Hestia-Cart': '1'
      },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r
        .json()
        .then(function (data) {
          return { ok: r.ok, data: data };
        })
        .catch(function () {
          return { ok: r.ok, data: null };
        });
    });
  }

  function renderDrawerFromCartPayload(parsed) {
    var d = getDrawer();
    if (!d || !parsed || !parsed.sections) return false;
    if (typeof d.renderContents === 'function') {
      try {
        d.renderContents(parsed);
        maskMysteryGiftInDrawer();
        return true;
      } catch (e) {}
    }
    return false;
  }

  function isPrimaryLineLoose(item) {
    if (!item) return false;
    var pid = Number(item.product_id);
    if (pid === HESTIA_PRODUCT_ID || pid === HAIRLINE_PRODUCT_ID) return true;
    var handle = (item.handle || '').toLowerCase();
    return handle.indexOf('hestia') !== -1 || handle.indexOf('hairline') !== -1 || handle.indexOf('hair-powder') !== -1;
  }

  function isGiftLine(item) {
    if (!item) return false;
    var vid = Number(item.variant_id);
    var pid = Number(item.product_id);
    if (ALL_GIFT_VARIANT_IDS.indexOf(vid) !== -1) return true;
    if (ALL_GIFT_PRODUCT_IDS.indexOf(pid) !== -1) return true;
    var props = item.properties || {};
    if (
      (props._hestia_gift === 'true' || props._hestia_gift === true || props._free_item === 'true' || props._free_item === true) &&
      !isPrimaryLineLoose(item)
    ) {
      return true;
    }
    var handle = (item.handle || '').toLowerCase();
    if (
      handle === 'makeup-bag' ||
      handle === 'travel-makeup-bag' ||
      handle === 'moosh-makeup-bag' ||
      handle === 'mystery-gift' ||
      handle === 'facial-gua-sha-board-and-muscle-stripping-stick' ||
      handle.indexOf('gua-sha') !== -1 ||
      handle.indexOf('makeup-bag') !== -1 ||
      handle.indexOf('mystery') !== -1
    ) {
      return true;
    }
    var title = (item.product_title || item.title || '').toLowerCase();
    if (
      title.indexOf('mystery gift') !== -1 ||
      title.indexOf('makeup bag') !== -1 ||
      title.indexOf('gua sha') !== -1
    ) {
      return true;
    }
    return false;
  }

  function isHestiaLine(item) {
    return item && Number(item.product_id) === HESTIA_PRODUCT_ID;
  }

  function isHairlineLine(item) {
    return item && Number(item.product_id) === HAIRLINE_PRODUCT_ID;
  }

  /** Paid primary for B1G3-style deals: HESTIA stick OR hairline powder. */
  function isPrimaryLine(item) {
    return isHestiaLine(item) || isHairlineLine(item);
  }

  function isBundleLine(item) {
    return isPrimaryLine(item) || isGiftLine(item);
  }

  function hestiaQty(cart) {
    return (cart.items || []).reduce(function (n, i) {
      return n + (isHestiaLine(i) ? i.quantity || 0 : 0);
    }, 0);
  }

  function hairlineQty(cart) {
    return (cart.items || []).reduce(function (n, i) {
      return n + (isHairlineLine(i) ? i.quantity || 0 : 0);
    }, 0);
  }

  function primaryQty(cart) {
    return hestiaQty(cart) + hairlineQty(cart);
  }

  /** B1G3 gifts require 2 paid primaries (2 sticks OR 2 powders). One alone cannot keep free bag+mystery. */
  function dealPrimarySatisfied(cart) {
    return hestiaQty(cart) >= 2 || hairlineQty(cart) >= 2;
  }

  function giftsAllowed(cart) {
    return dealPrimarySatisfied(cart);
  }

  function cartIsGiftOnly(cart) {
    if (!cart || !giftLines(cart).length) return false;
    return primaryQty(cart) === 0;
  }

  function giftLines(cart) {
    return (cart.items || []).filter(isGiftLine);
  }

  function bundleLines(cart) {
    return (cart.items || []).filter(isBundleLine);
  }

  function newDealId() {
    return 'hd' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  function getDealId(item) {
    if (!item) return null;
    var p = item.properties || {};
    return p._hestia_deal_id || null;
  }

  function isPaidStick(item) {
    return isHestiaLine(item) && Number(item.final_line_price || item.line_price || 0) > 0;
  }

  function isFreeStick(item) {
    return isHestiaLine(item) && Number(item.final_line_price || item.line_price || 0) === 0;
  }

  function isBagLine(item) {
    if (!item) return false;
    var pid = Number(item.product_id);
    var vid = Number(item.variant_id);
    return ALL_BAG_VARIANT_IDS.indexOf(vid) !== -1 || pid === GIFT_PRODUCT_IDS.bag || LEGACY_BAG_PRODUCT_IDS.indexOf(pid) !== -1;
  }

  function isMysteryLine(item) {
    if (!item) return false;
    return Number(item.variant_id) === GIFT_VARIANT_IDS.mystery || Number(item.product_id) === GIFT_PRODUCT_IDS.mystery;
  }

  /** One B1G3 deal from a trash trigger — never the whole cart when other deals remain. */
  function buildDealGroup(cart, trigger) {
    var items = (cart && cart.items) || [];
    if (!trigger) return [];
    var dealId = getDealId(trigger);
    if (dealId) {
      var tagged = items.filter(function (i) { return getDealId(i) === dealId; });
      if (tagged.length) return tagged;
    }
    var group = [trigger];
    var used = {};
    used[trigger.key] = true;
    function take(pred) {
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (!it || used[it.key]) continue;
        if (pred(it)) {
          used[it.key] = true;
          group.push(it);
          return it;
        }
      }
      return null;
    }
    if (isHestiaLine(trigger)) {
      if (isPaidStick(trigger)) take(isFreeStick);
      else take(isPaidStick);
      take(isBagLine);
      take(isMysteryLine);
    } else if (isHairlineLine(trigger)) {
      // Pair the other powder line(s) in this deal, then free gifts
      for (var hi = 0; hi < items.length; hi++) {
        var hItem = items[hi];
        if (!hItem || used[hItem.key]) continue;
        if (!isHairlineLine(hItem)) continue;
        if (dealId && getDealId(hItem) && getDealId(hItem) !== dealId) continue;
        used[hItem.key] = true;
        group.push(hItem);
      }
      take(isBagLine);
      take(isMysteryLine);
    } else if (isGiftLine(trigger)) {
      // Trash on bag/mystery: tear down the owning deal (powder or stick + gifts)
      take(isHairlineLine);
      take(isHairlineLine);
      take(isPaidStick);
      take(isFreeStick);
      take(isBagLine);
      take(isMysteryLine);
    } else {
      take(isPaidStick);
      take(isFreeStick);
      take(isBagLine);
      take(isMysteryLine);
    }
    return group;
  }


  function missingGifts(cart) {
    var present = {};
    giftLines(cart).forEach(function (i) {
      present[Number(i.variant_id)] = true;
      present[Number(i.product_id)] = true;
    });
    var missing = [];
    if (!present[GIFT_VARIANT_IDS.bag] && !present[GIFT_PRODUCT_IDS.bag]) missing.push(GIFT_VARIANT_IDS.bag);
    if (!present[GIFT_VARIANT_IDS.mystery] && !present[GIFT_PRODUCT_IDS.mystery]) {
      missing.push(GIFT_VARIANT_IDS.mystery);
    }
    return missing;
  }


  function onPowderPdp() {
    var path = ((window.location && window.location.pathname) || '').toLowerCase();
    if (path.indexOf('hairline') !== -1 || path.indexOf('hair-powder') !== -1) return true;
    return !!document.querySelector('[data-hairline-sticky-atc], .hairline-shade-bubbles, [data-hairline-sticky-opt]');
  }

  /** Powder B1G3 selected in sticky or QB (Buy 1 Get 3). */
  function wantsPowderB1g3Bundle() {
    var stickyBuy1 = document.querySelector('[data-hairline-sticky-opt="buy1"].is-active, [data-hairline-sticky-opt="buy1"][aria-pressed="true"]');
    if (stickyBuy1) return false;
    var stickyB1g3 = document.querySelector('[data-hairline-sticky-opt="b1g3"].is-active, [data-hairline-sticky-opt="b1g3"][aria-pressed="true"]');
    if (stickyB1g3) return true;
    var activeSticky = document.querySelector('[data-hairline-sticky-opt].is-active, [data-hairline-sticky-opt][aria-pressed="true"]');
    if (activeSticky) {
      return activeSticky.getAttribute('data-hairline-sticky-opt') === 'b1g3';
    }
    if (!onPowderPdp()) return false;
    var sel = document.querySelector('.quantity-break-option.selected, label.quantity-break-option.selected');
    if (sel) {
      // Deal titles are editable in the theme editor, so judge by quantity first, text second.
      var selInp = sel.querySelector('input.quantity-break-input');
      var selQty = selInp ? parseInt(selInp.value, 10) || 1 : 0;
      if (selQty >= 2) return true;
      if (selQty === 1) return false;
      var t = (sel.textContent || '').toLowerCase();
      if (t.indexOf('get 3') !== -1 || t.indexOf('b1g3') !== -1) return true;
      if (t.indexOf('buy 1 get') !== -1) return true;
      if (t.indexOf('buy 1') !== -1 && t.indexOf('get') === -1) return false;
    }
    // Default powder offer is B1G3 when sticky defaults to it
    if (document.querySelector('[data-hairline-sticky-atc]')) {
      var buy1 = document.querySelector('[data-hairline-sticky-opt="buy1"][aria-pressed="true"], [data-hairline-sticky-opt="buy1"].is-active');
      return !buy1;
    }
    return false;
  }

  function resolvePowderVariantId(cart) {
    var powders = ((cart && cart.items) || []).filter(isHairlineLine);
    if (powders.length) return Number(powders[0].variant_id);
    try {
      if (typeof window.Elixir_GetProductFormVariantId === 'function') {
        var id = window.Elixir_GetProductFormVariantId();
        if (id) return Number(id);
      }
    } catch (e) {}
    var inp = document.querySelector(
      '.quantity-break-option.selected input[data-variant-id], .quantity-break-option.selected [data-variant-id], form[action*="/cart/add"] input[name="id"]'
    );
    if (inp) {
      var v = inp.getAttribute('data-variant-id') || inp.value;
      if (v) return Number(v);
    }
    // Shade #2 then #1 selected chips
    var chip = document.querySelector('.qb-swatch[aria-selected="true"][data-variant-id], .qb-swatch.is-selected[data-variant-id]');
    if (chip && chip.getAttribute('data-variant-id')) return Number(chip.getAttribute('data-variant-id'));
    return null;
  }

  /** Ensure powder deal = ≥2 powders + bag + mystery (Shopify BXGY + Free Gifts then price it). */
  function ensurePowderB1g3Bundle(cart) {
    if (!cart || claiming || syncing || removingBundle) return Promise.resolve(cart);
    if (!(wantsPowderB1g3Bundle() || (hairlineQty(cart) >= 1 && giftLines(cart).length))) {
      return Promise.resolve(cart);
    }
    if (!wantsPowderB1g3Bundle() && hairlineQty(cart) < 1) return Promise.resolve(cart);

    var items = [];
    var dealId = newDealId();
    var existing = ((cart.items || []).filter(isHairlineLine)[0]);
    if (existing && getDealId(existing)) dealId = getDealId(existing);

    if (hairlineQty(cart) < 2) {
      var vid = resolvePowderVariantId(cart);
      if (!vid) return Promise.resolve(cart);
      items.push({
        id: vid,
        quantity: hairlineQty(cart) < 1 ? 2 : 1,
        properties: { _hestia_bundle: 'b1g3', _hestia_deal_id: dealId, _powder_deal: 'b1g3' }
      });
    }
    missingGifts(cart).forEach(function (id) {
      items.push({
        id: id,
        quantity: 1,
        properties: { _free_item: 'true', _hestia_gift: 'true', _hestia_bundle: 'b1g3', _hestia_deal_id: dealId }
      });
    });
    if (!items.length) return Promise.resolve(cart);

    claiming = true;
    syncing = true;
    return postJson(cartUrl('cart/add.js'), {
      items: items,
      sections: getSections(),
      sections_url: window.location.pathname
    })
      .then(function (res) {
        claiming = false;
        syncing = false;
        if (!res.ok) return cart;
        if (res.data && res.data.sections) renderDrawerFromCartPayload(res.data);
        return fetchCart(true).then(function (fresh) {
          applyCartToUi(fresh || cart);
          return fresh || cart;
        });
      })
      .catch(function () {
        claiming = false;
        syncing = false;
        return cart;
      });
  }

  function wantsB1g3Bundle() {
    // HESTIA stick B1G3 gift inject ONLY — never Hairline Powder BOGO ("Get 1 Free" / "Get 2 Free")
    var activeSticky = document.querySelector('[data-hestia-sticky-opt].is-active');
    if (activeSticky) {
      return activeSticky.getAttribute('data-hestia-sticky-opt') === 'b1g3';
    }
    if (document.querySelector('[data-hairline-sticky-atc]') || onPowderPdp()) {
      return false;
    }
    var path = ((window.location && window.location.pathname) || '').toLowerCase();
    // Powder B1G3 is fulfilled by QB free_gift bars + ensurePowderB1g3Bundle — never inject a HESTIA free stick here.
    if (path.indexOf('hairline') !== -1 || path.indexOf('hair-powder') !== -1) {
      return false;
    }
    var onHestiaPdp = path.indexOf('hestia') !== -1;
    if (onHestiaPdp) {
      var sel = document.querySelector('.quantity-break-option.selected, label.quantity-break-option.selected');
      if (sel) {
        var t = (sel.textContent || '').toLowerCase();
        if (t.indexOf('get 3') !== -1 || t.indexOf('b1g3') !== -1) return true;
        if (t.indexOf('buy 1 get') !== -1) return true;
        if (t.indexOf('get 1 free') !== -1 || t.indexOf('get 2 free') !== -1) return true;
      }
    }
    // Sticky bar defaults to B1G3 when HESTIA sticky present and buy1 is not pressed
    if (document.querySelector('[data-hestia-sticky-atc]')) {
      var buy1 = document.querySelector('[data-hestia-sticky-opt="buy1"][aria-pressed="true"], [data-hestia-sticky-opt="buy1"].is-active');
      return !buy1;
    }
    return false;
  }

  /** After ATC: if B1G3 deal selected, auto-add free stick + bag + mystery (no Claim click). */
  function ensureB1g3Bundle(cart) {
    if (!cart || claiming || syncing || removingBundle) return Promise.resolve(cart);
    if (!wantsB1g3Bundle()) return Promise.resolve(cart);
    if (hestiaQty(cart) < 1) return Promise.resolve(cart);
    var needStick = hestiaQty(cart) < 2;
    var gifts = missingGifts(cart);
    if (!needStick && !gifts.length) return Promise.resolve(cart);
    // Reuse claim path (adds stick if needed + missing gifts)
    return new Promise(function (resolve) {
      claimFreeGifts();
      // claimFreeGifts is async; poll briefly for completion
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        if (!claiming || tries > 40) {
          clearInterval(t);
          fetchCart().then(resolve);
        }
      }, 100);
    });
  }


  /** DOM: is this cart row part of the HESTIA bundle? */
  function rowIsBundle(row) {
    if (!row) return false;
    var text = (row.textContent || '').toLowerCase();
    if (text.indexOf('hestia') !== -1) return true;
    if (text.indexOf('hairline') !== -1) return true;
    if (text.indexOf('hair line') !== -1) return true;
    if (text.indexOf('shadow powder') !== -1) return true;
    if (text.indexOf('makeup bag') !== -1) return true;
    if (text.indexOf('mystery gift') !== -1) return true;
    if (text.indexOf('gua sha') !== -1) return true;
    if (text.indexOf('free gift') !== -1) return true;
    var btn = row.querySelector('[data-variant-id]');
    if (btn) {
      var vid = Number(btn.getAttribute('data-variant-id'));
      if (ALL_GIFT_VARIANT_IDS.indexOf(vid) !== -1) return true;
    }
    var link = row.querySelector('a[href*="/products/"]');
    if (link) {
      var href = (link.getAttribute('href') || '').toLowerCase();
      if (
        href.indexOf('hestia') !== -1 ||
        href.indexOf('hairline') !== -1 ||
        href.indexOf('hair-powder') !== -1 ||
        href.indexOf('shadow-powder') !== -1 ||
        href.indexOf('makeup-bag') !== -1 ||
        href.indexOf('travel-makeup-bag') !== -1 ||
        href.indexOf('moosh-makeup-bag') !== -1 ||
        href.indexOf('mystery-gift') !== -1 ||
        href.indexOf('facial-gua-sha') !== -1 ||
        href.indexOf('gua-sha') !== -1
      ) {
        return true;
      }
    }
    return false;
  }

  /** Instant UI: hide every bundle row so trash feels immediate */
  function optimisticHideDealRows(keys) {
    var drawer = getDrawer();
    if (!drawer) return;
    var keySet = {};
    (keys || []).forEach(function (k) { keySet[k] = true; });
    drawer.querySelectorAll('.cart-item').forEach(function (row) {
      var keyEl = row.querySelector('[data-cart-item-key], [data-key]');
      var key = row.getAttribute('data-key') || (keyEl && (keyEl.getAttribute('data-cart-item-key') || keyEl.getAttribute('data-key')));
      if (key && keySet[key]) {
        row.style.display = 'none';
        row.setAttribute('data-hestia-removing', '1');
        return;
      }
      // If keys unknown, hide matching hestia/gift rows only when single deal
      if (!keys || !keys.length) return;
    });
  }

  function optimisticHideBundleRows() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.querySelectorAll('.cart-item').forEach(function (row) {
      if (rowIsBundle(row)) {
        row.style.display = 'none';
        row.setAttribute('data-hestia-removing', '1');
      }
    });
  }

  function cartHasItems(cart) {
    if (!cart) return false;
    if (typeof cart.item_count === 'number') return cart.item_count > 0;
    if (cart.items && cart.items.length) return true;
    return false;
  }

  function clearInjectedEmptyUi(drawer) {
    if (!drawer) return;
    drawer.querySelectorAll('[data-hestia-cart-empty]').forEach(function (n) {
      // Only remove engine-injected empty UI, not the theme empty host contents we may have replaced
      var host = n.closest('.cart-drawer-empty, .hestia-cart-empty-host');
      if (host && host.querySelector('[data-hestia-cart-empty]') === n && host.children.length === 1) {
        // leave host; just clear injected markup so theme empty can take over later
        n.remove();
        return;
      }
      n.remove();
    });
  }


  var MYSTERY_GIFT_IMG = 'https://cdn.shopify.com/s/files/1/0745/6892/5272/files/mystery-gift-box.png?v=1793066700';

  /** Customer-facing cart: always Mystery Gift — never Gua Sha / facial scraper / Razor Pink. */
  function maskMysteryGiftInDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.querySelectorAll('.cart-item').forEach(function (row) {
      var vid = Number(row.getAttribute('data-variant-id') || 0);
      var href = '';
      var link = row.querySelector('a[href*="/products/"]');
      if (link) href = (link.getAttribute('href') || '').toLowerCase();
      var text = (row.textContent || '').toLowerCase();
      var isMystery =
        vid === GIFT_VARIANT_IDS.mystery ||
        href.indexOf('facial-gua-sha') !== -1 ||
        href.indexOf('gua-sha') !== -1 ||
        href.indexOf('mystery-gift') !== -1 ||
        text.indexOf('gua sha') !== -1 ||
        text.indexOf('facial scraper') !== -1 ||
        text.indexOf('razor pink') !== -1;
      if (!isMystery) return;
      row.setAttribute('data-mystery-gift-masked', '1');
      row.querySelectorAll('.cart-item__name').forEach(function (el) {
        el.textContent = 'Mystery Gift';
      });
      row.querySelectorAll('.product-option').forEach(function (opt) {
        var t = (opt.textContent || '').toLowerCase();
        if (
          t.indexOf('gift') !== -1 ||
          t.indexOf('surprise') !== -1 ||
          t.indexOf('shape') !== -1 ||
          t.indexOf('razor') !== -1 ||
          t.indexOf('gua') !== -1 ||
          t.indexOf('scraper') !== -1
        ) {
          opt.style.display = 'none';
        }
      });
      row.querySelectorAll('img.cart-item__image, .cart-item__image').forEach(function (img) {
        if (!img || !img.tagName) return;
        img.setAttribute('src', MYSTERY_GIFT_IMG);
        img.removeAttribute('srcset');
        img.setAttribute('alt', 'Mystery Gift');
      });
    });
  }


  /** Grüns-style rich cart chrome in Moosh carmesi — settings_data upserts are blocked on this theme. */
  function moneyFromCents(cents) {
    var n = (Number(cents) || 0) / 100;
    try {
      return (window.Shopify && Shopify.formatMoney)
        ? Shopify.formatMoney(cents, (window.theme && theme.moneyFormat) || '${{amount}}')
        : '$' + n.toFixed(2);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function cartCompareAt(cart) {
    var items = (cart && cart.items) || [];
    var sum = 0;
    items.forEach(function (it) {
      var unit = Number(it.original_line_price != null ? it.original_line_price : (it.compare_at_price || it.price || 0) * (it.quantity || 1));
      // prefer original_line_price; fallback compare_at * qty or price * qty
      if (it.original_line_price != null) sum += Number(it.original_line_price);
      else if (it.compare_at_price) sum += Number(it.compare_at_price) * (it.quantity || 1);
      else sum += Number(it.price || 0) * (it.quantity || 1);
    });
    return sum;
  }

  function cartSavings(cart) {
    var compare = cartCompareAt(cart);
    var total = Number((cart && (cart.total_price != null ? cart.total_price : cart.items_subtotal_price)) || 0);
    var saved = Math.max(0, compare - total);
    var pct = compare > 0 ? Math.round((saved / compare) * 100) : 0;
    return { compare: compare, total: total, saved: saved, pct: pct };
  }

  function injectRichCartChrome(cart) {
    var drawer = getDrawer();
    if (!drawer || !cartHasItems(cart)) {
      if (drawer) {
        drawer.querySelectorAll('[data-hestia-rich-chrome]').forEach(function (n) { n.remove(); });
      }
      return;
    }

    // QA cleanup: the theme's own blocks already render the free-shipping progress bar,
    // order totals, payment icons and trust line. The engine used to inject a second copy
    // of each (two "Congrats! FREE SHIPPING" bars, two "Order Summary" panels, text
    // payment pills), and its summary labelled the discounted total as "Subtotal", which
    // made the maths read wrong (Subtotal $55.84 − $120.33 = $55.84). Remove leftovers.
    drawer.querySelectorAll(
      '[data-hestia-ship-progress], [data-hestia-order-summary], [data-hestia-trust-row], [data-hestia-pay-icons]'
    ).forEach(function (n) { n.remove(); });

    var headerHost =
      drawer.querySelector('.cart-drawer-header-blocks') ||
      drawer.querySelector('.cart-drawer-header') ||
      drawer.querySelector('[id*="CartDrawer-Header"]') ||
      drawer.querySelector('.drawer__header');

    // Cart banner text comes from the theme editor's "Cart banner" block. The engine used to
    // overwrite it with "Limited Time Discount Auto-Applied" (and re-add the banner if the block
    // was deleted), so editor changes never showed. Leftovers from that are removed here.
    drawer.querySelectorAll('[data-hestia-banner-text], [data-hestia-discount-banner]').forEach(function (n) { n.remove(); });
    drawer.querySelectorAll('.hestia-discount-banner--overridden').forEach(function (n) { n.classList.remove('hestia-discount-banner--overridden'); });

    // —— SURPRISE / Free Gift badges on mystery + free gift rows ——
    drawer.querySelectorAll('.cart-item').forEach(function (row) {
      var text = (row.textContent || '').toLowerCase();
      var isMystery =
        row.getAttribute('data-mystery-gift-masked') === '1' ||
        text.indexOf('mystery gift') !== -1 ||
        text.indexOf('gua sha') !== -1;
      var isFree =
        isMystery ||
        text.indexOf('makeup bag') !== -1 ||
        !!row.querySelector('.cartitem-free-product-label, [class*="free-product"], .price--free');
      if (!isFree) return;
      if (isMystery && !row.querySelector('[data-hestia-surprise-badge], .cart-item__surprise-badge')) {
        var badge = document.createElement('span');
        badge.className = 'hestia-surprise-badge cart-item__surprise-badge';
        badge.setAttribute('data-hestia-rich-chrome', '1');
        badge.setAttribute('data-hestia-surprise-badge', '1');
        badge.textContent = 'SURPRISE';
        var qty = row.querySelector('.cart-item__quantity, .quantity, cart-remove-button, .cart-item__totals');
        if (qty && qty.parentNode) qty.parentNode.insertBefore(badge, qty);
        else row.appendChild(badge);
      }
      // Ensure Free Gift label
      if (!row.querySelector('.cartitem-free-product-label, [data-hestia-free-gift-badge]')) {
        var fg = document.createElement('span');
        fg.className = 'hestia-free-gift-badge cartitem-free-product-label';
        fg.setAttribute('data-hestia-rich-chrome', '1');
        fg.setAttribute('data-hestia-free-gift-badge', '1');
        fg.textContent = 'Free Gift';
        var name = row.querySelector('.cart-item__name, a.cart-item__name, .cart-item__details');
        if (name) name.insertAdjacentElement('afterend', fg);
        else row.appendChild(fg);
      }
      // Force FREE price display
      row.querySelectorAll('.price, .cart-item__price, .price-item').forEach(function (p) {
        var t = (p.textContent || '').replace(/\s+/g, ' ').trim();
        if (/^\$?0(\.00)?$/.test(t) || t.toLowerCase() === 'free') {
          p.textContent = 'FREE';
          p.classList.add('price--free');
          p.setAttribute('data-price-free', '1');
        }
      });
    });

  }


  function applyCartToUi(cart) {
    lastCart = cart;
    ensureEmptyUi(cart);
    injectClaimUi(cart);
    maskMysteryGiftInDrawer();
    injectRichCartChrome(cart);
    var d = getDrawer();
    if (d) {
      if (!cartHasItems(cart)) d.classList.add('is-empty');
      else d.classList.remove('is-empty');
    }
  }

  function forceEmptyDrawerSections() {
    var ids = getSections();
    if (!ids || !ids.length) return Promise.resolve();
    var sep = window.location.search ? '&' : '?';
    var url = window.location.pathname + window.location.search + sep + 'sections=' + encodeURIComponent(ids.join(','));
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Hestia-Cart': '1' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        if (sections) renderDrawerFromCartPayload({ sections: sections });
      })
      .catch(function () {});
  }

  function finishBundleRemoval(data) {
    removingBundle = false;
    syncing = false;
    if (data) {
      lastCart = data;
      renderDrawerFromCartPayload(data);
      applyCartToUi(data);
      if (cartIsGiftOnly(data) || (!giftsAllowed(data) && giftLines(data).length)) {
        return removeOrphanGifts(data, true);
      }
      setCheckoutBlocked(false);
      return data;
    }
    return enforceDealIntegrity({ forceFetch: true });
  }

  function domLooksLikeOnlyBundle() {
    var rows = document.querySelectorAll('cart-drawer .cart-item, #CartDrawer .cart-item');
    if (!rows.length) return false;
    for (var i = 0; i < rows.length; i++) {
      if (!rowIsBundle(rows[i])) return false;
    }
    return true;
  }

  function clearCartFast() {
    var sections = getSections();
    return postJson(cartUrl('cart/clear.js'), {
      sections: sections,
      sections_url: window.location.pathname
    }).then(function (res) {
      var data = (res && res.data) || { items: [], item_count: 0 };
      if (!data.items) {
        data.items = [];
        data.item_count = 0;
      }
      applyCartToUi(data);
      if (data.sections) {
        renderDrawerFromCartPayload(data);
        return finishBundleRemoval(data);
      }
      // Don't block UX on section HTML — paint empty now, refresh HTML in background
      ensureEmptyUi(data);
      finishBundleRemoval(data);
      forceEmptyDrawerSections();
      return data;
    });
  }

  /**
   * Remove ONE deal (trigger stick/gift + paired free stick + bag + mystery).
   * Clears cart only when that was the last remaining deal.
   */
  function removeOneDeal(triggerItem) {
    if (removingBundle) return Promise.resolve();
    removingBundle = true;
    syncing = true;

    return fetchCart()
      .then(function (cart) {
        var trigger = triggerItem;
        if (!trigger && lastCart && lastCart.items) {
          // fallback: first bundle line
          trigger = bundleLines(cart)[0];
        }
        // If trigger is a key/string from DOM, resolve item
        if (trigger && !trigger.key && typeof trigger === 'object' && trigger.getAttribute) {
          trigger = null;
        }
        var group = buildDealGroup(cart, trigger);
        if (!group.length) {
          group = bundleLines(cart);
        }
        var updates = {};
        group.forEach(function (line) {
          if (line && line.key) updates[line.key] = 0;
        });
        var keys = Object.keys(updates);
        if (!keys.length) return finishBundleRemoval(cart);

        optimisticHideDealRows(keys);

        var remaining = (cart.items || []).filter(function (i) { return !updates[i.key]; });
        if (!remaining.length) {
          var drawer = getDrawer();
          if (drawer) drawer.classList.add('is-empty');
          ensureEmptyUi({ items: [], item_count: 0 });
          return clearCartFast();
        }

        return postJson(cartUrl('cart/update.js'), {
          updates: updates,
          sections: getSections(),
          sections_url: window.location.pathname
        }).then(function (res) {
          return finishBundleRemoval(res && res.data);
        });
      })
      .catch(function () {
        removingBundle = false;
        syncing = false;
        return fetchCart().then(applyCartToUi);
      });
  }

  /** Legacy name — now removes one deal, not every HESTIA line. */
  function removeEntireBundle(triggerItem) {
    return removeOneDeal(triggerItem);
  }

  window.__hestiaRemoveBundle = removeOneDeal;
  window.__hestiaRemoveOneDeal = removeOneDeal;

  /** If gifts landed without a stick, add the PDP-selected HESTIA variant; otherwise purge gifts */
  function recoverBundleOrPurge(cart) {
    var stickId = null;
    try {
      if (typeof window.Elixir_GetProductFormVariantId === 'function') {
        stickId = window.Elixir_GetProductFormVariantId();
      }
      if (!stickId) {
        var inp = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] input[name^="items["][name*="[id]"]');
        if (inp && inp.value) stickId = inp.value;
      }
    } catch (e) {}
    stickId = stickId ? Number(stickId) : null;
    if (!stickId) return removeOrphanGifts(cart);

    syncing = true;
    return postJson(cartUrl('cart/add.js'), {
      items: [{ id: stickId, quantity: 1, properties: { _hestia_bundle: 'b1g3', _hestia_deal_id: newDealId() } }],
      sections: getSections(),
      sections_url: window.location.pathname
    })
      .then(function (res) {
        syncing = false;
        if (!res.ok) return removeOrphanGifts(cart);
        var data = res.data;
        if (data && data.items) {
          lastCart = data.item_count != null ? data : { items: data.items, item_count: data.items.length };
        }
        // Re-fetch authoritative cart — BXGY may add free stick
        return fetchCart().then(function (fresh) {
          // Powder ATC can land gifts + powder without a HESTIA stick — keep those deals.
          if (primaryQty(fresh) === 0) return removeOrphanGifts(fresh);
          applyCartToUi(fresh);
          var d = getDrawer();
          if (!d || !d.classList.contains('active')) openDrawer();
          return fresh;
        });
      })
      .catch(function () {
        syncing = false;
        return removeOrphanGifts(cart);
      });
  }


  /**
   * Purge free bag + mystery unless a full deal primary remains (≥2 sticks OR ≥2 powders).
   * force=true bypasses syncing/removingBundle — used for gift-only emergency + checkout.
   */
  function removeOrphanGifts(cart, force) {
    if (!cart) return Promise.resolve(cart);
    if (!force && (syncing || removingBundle)) return Promise.resolve(cart);
    if (giftsAllowed(cart)) return Promise.resolve(cart);
    // Never trash powder B1G3 gifts while the deal is selected — complete the 2nd powder instead.
    if (wantsPowderB1g3Bundle() && hairlineQty(cart) >= 1) {
      return ensurePowderB1g3Bundle(cart);
    }
    var gifts = giftLines(cart);
    if (!gifts.length) return Promise.resolve(cart);

    syncing = true;
    var updates = {};
    gifts.forEach(function (g) {
      if (g && g.key) updates[g.key] = 0;
    });
    if (!Object.keys(updates).length) {
      (cart.items || []).forEach(function (it, idx) {
        if (isGiftLine(it)) updates[idx + 1] = 0;
      });
    }
    optimisticHideDealRows(Object.keys(updates));
    return postJson(cartUrl('cart/update.js'), {
      updates: updates,
      sections: getSections(),
      sections_url: window.location.pathname
    })
      .then(function (res) {
        syncing = false;
        var data = res && res.data;
        if (data) {
          lastCart = data;
          if (cartIsGiftOnly(data)) {
            return clearCartFast();
          }
          renderDrawerFromCartPayload(data);
          applyCartToUi(data);
          setCheckoutBlocked(cartIsGiftOnly(data) || (!giftsAllowed(data) && giftLines(data).length > 0));
          return data;
        }
        return cart;
      })
      .catch(function () {
        syncing = false;
        return cart;
      });
  }

  function enforceDealIntegrity(opts) {
    opts = opts || {};
    return fetchCart(!!opts.forceFetch).then(function (cart) {
      if (!cart) return cart;
      // Powder B1G3: complete 2 powders + gifts BEFORE orphan purge (fixes checkout → single $39.99).
      if (
        !giftsAllowed(cart) &&
        giftLines(cart).length &&
        (wantsPowderB1g3Bundle() || hairlineQty(cart) >= 1)
      ) {
        return ensurePowderB1g3Bundle(cart).then(function (next) {
          next = next || cart;
          if (cartIsGiftOnly(next) || (!giftsAllowed(next) && giftLines(next).length)) {
            // Still incomplete and not a powder B1G3 intent → purge
            if (!wantsPowderB1g3Bundle() && hairlineQty(next) < 2) {
              return removeOrphanGifts(next, true);
            }
          }
          // Block only gift-only / gift-without-primary — never block a valid Buy 1 (1 powder, no gifts).
          setCheckoutBlocked(
            cartIsGiftOnly(next) || (!dealPrimarySatisfied(next) && giftLines(next).length > 0)
          );
          applyCartToUi(next);
          return next;
        });
      }
      if (cartIsGiftOnly(cart) || (!giftsAllowed(cart) && giftLines(cart).length)) {
        return removeOrphanGifts(cart, true);
      }
      setCheckoutBlocked(false);
      applyCartToUi(cart);
      return cart;
    });
  }

  function setCheckoutBlocked(blocked) {
    var nodes = document.querySelectorAll(
      'cart-drawer button[name="checkout"], cart-drawer [name="checkout"], cart-drawer .cart__checkout-button, cart-drawer #CartDrawer-Checkout, cart-drawer a[href="/checkout"]'
    );
    nodes.forEach(function (btn) {
      if (!btn) return;
      if (blocked) {
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('data-hestia-checkout-blocked', '1');
        if ('disabled' in btn) btn.disabled = true;
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.55';
      } else if (btn.getAttribute('data-hestia-checkout-blocked') === '1') {
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('data-hestia-checkout-blocked');
        if ('disabled' in btn) btn.disabled = false;
        btn.style.pointerEvents = '';
        btn.style.opacity = '';
      }
    });
  }

  function claimFreeGifts() {
    if (claiming) return;
    claiming = true;
    var btn = document.querySelector('[data-hestia-claim-gifts]');
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.textContent = 'Adding gifts…';
    }

    fetchCart()
      .then(function (cart) {
        var sticks = (cart.items || []).filter(isHestiaLine);
        if (!sticks.length) throw new Error('no-stick');
        var primary = sticks[0];
        var items = [];
        var dealId = getDealId(primary) || newDealId();
        if (hestiaQty(cart) < 2) {
          items.push({
            id: primary.variant_id,
            quantity: 1,
            properties: { _hestia_bundle: 'b1g3', _hestia_deal_id: dealId }
          });
        }
        missingGifts(cart).forEach(function (id) {
          items.push({
            id: id,
            quantity: 1,
            properties: { _free_item: 'true', _hestia_gift: 'true', _hestia_bundle: 'b1g3', _hestia_deal_id: dealId }
          });
        });
        if (!items.length) return cart;
        return postJson(cartUrl('cart/add.js'), {
          items: items,
          sections: getSections(),
          sections_url: window.location.pathname
        }).then(function (res) {
          if (!res.ok) throw new Error('add-failed');
          // cart/add.js multi-item payloads often omit item_count and only return added lines.
          // Always re-fetch the full cart, then paint sections from the add response (or refresh).
          if (res.data && res.data.sections) {
            renderDrawerFromCartPayload(res.data);
          }
          return fetchCart().then(function (fresh) {
            if (!(res.data && res.data.sections)) {
              return forceEmptyDrawerSections().then(function () {
                return fresh;
              });
            }
            return fresh;
          });
        });
      })
      .then(function (cart) {
        claiming = false;
        applyCartToUi(cart);
        openDrawer();
      })
      .catch(function () {
        claiming = false;
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          btn.textContent = 'Claim FREE Gifts';
        }
      });
  }

  function buildClaimCard(cart) {
    if (hestiaQty(cart) < 1 || missingGifts(cart).length === 0) return null;
    var el = document.createElement('div');
    el.className = 'hestia-claim-gifts';
    el.setAttribute('data-hestia-claim-card', '1');
    el.innerHTML =
      '<div class="hestia-claim-gifts__badge">Limited offer</div>' +
      '<div class="hestia-claim-gifts__copy">' +
      '<strong>Claim your FREE gifts</strong>' +
      '<p>Makeup Bag + Mystery Gift — included with Buy 1 Get 3 Free. Same price as one stick.</p>' +
      '</div>' +
      '<button type="button" class="hestia-claim-gifts__btn" data-hestia-claim-gifts>Claim FREE Gifts</button>';
    return el;
  }

  function injectClaimUi(cart) {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.querySelectorAll('[data-hestia-claim-card]').forEach(function (n) {
      n.remove();
    });
    if (!cartHasItems(cart) || hestiaQty(cart) < 1) return;
    var card = buildClaimCard(cart);
    if (!card) return;
    var host =
      drawer.querySelector('.cart-drawer-upsell-sections') ||
      drawer.querySelector('.drawer__footer') ||
      drawer.querySelector('cart-drawer-items') ||
      drawer.querySelector('.drawer__inner');
    if (!host) return;
    if (host.classList.contains('drawer__footer')) host.insertBefore(card, host.firstChild);
    else host.appendChild(card);
    var btn = card.querySelector('[data-hestia-claim-gifts]');
    if (btn) btn.addEventListener('click', claimFreeGifts);
  }

  function emptyUiHtml() {
    var path = ((window.location && window.location.pathname) || '').toLowerCase();
    var onPowder = path.indexOf('hairline') !== -1 || path.indexOf('hair-powder') !== -1;
    var onHestia = path.indexOf('hestia') !== -1;
    var shopUrl;
    var copy;
    var cta;
    if (onPowder || (!onHestia && document.querySelector('[data-hairline-sticky-atc]'))) {
      shopUrl = '/products/hairline-shadow-powder-makeup';
      copy = 'Add Moosh Hairline Powder and unlock <strong>Buy 1 Get 3 Free</strong> — 2 powders + Makeup Bag + Mystery Gift.';
      cta = 'Shop Hairline Powder';
    } else {
      shopUrl = '/products/hestia-color-changing-foundation-stick';
      copy = 'Add HESTIA® and unlock <strong>Buy 1 Get 3 Free</strong> — 2 sticks + Makeup Bag + Mystery Gift.';
      cta = 'Shop HESTIA®';
    }
    return (
      '<div class="hestia-cart-empty" data-hestia-cart-empty>' +
      '<div class="hestia-cart-empty__header">' +
      '<h2 class="hestia-cart-empty__title">Your Cart <span class="hestia-cart-empty__count">(0)</span></h2>' +
      '<button class="drawer__close hestia-cart-empty__close" type="button" data-hestia-cart-close aria-label="Close">' +
      '<span aria-hidden="true" style="font-size:22px;line-height:1;">×</span></button></div>' +
      '<div class="hestia-cart-empty__body">' +
      '<p class="hestia-cart-empty__eyebrow">You\'re in your cart</p>' +
      '<h3 class="hestia-cart-empty__heading">Your bag is empty</h3>' +
      '<p class="hestia-cart-empty__text">' + copy + '</p>' +
      '<a class="hestia-cart-empty__cta" href="' +
      shopUrl +
      '" data-hestia-empty-shop>' + cta + '</a>' +
      '<p class="hestia-cart-empty__trust">Free express shipping · 30-day money-back</p>' +
      '</div></div>'
    );
  }

  function ensureEmptyUi(cart) {
    var drawer = getDrawer();
    if (!drawer) return;
    var inner = drawer.querySelector('.drawer__inner');
    if (!inner) return;
    // Orphan gifts (bag/mystery without a stick) must never linger — clear then paint empty
    if (cart && (cartIsGiftOnly(cart) || (primaryQty(cart) === 0 && giftLines(cart).length))) {
      removeOrphanGifts(cart, true);
      return;
    }

    var isEmpty = !cartHasItems(cart);
    if (!isEmpty) {
      drawer.classList.remove('is-empty');
      // Critical: remove any injected empty UI left over from a stale cart/add payload
      // (multi-item add.js often omits item_count, which used to leave empty+filled stacked).
      clearInjectedEmptyUi(drawer);
      return;
    }
    drawer.classList.add('is-empty');
    if (drawer.querySelector('[data-hestia-cart-empty]')) return;

    var blank =
      drawer.querySelector('.cart-drawer-empty') || drawer.querySelector('.cart-drawer-empty__blocks');
    if (blank && blank.classList && blank.classList.contains('cart-drawer-empty')) {
      blank.innerHTML = emptyUiHtml();
      return;
    }
    if (blank && blank.classList && blank.classList.contains('cart-drawer-empty__blocks')) {
      blank.innerHTML = emptyUiHtml();
      return;
    }
    // Never inject empty UI on top of a filled drawer shell — only when empty zone exists
    // or drawer currently has no line-item shell.
    if (inner.querySelector('cart-drawer-items, .cart-drawer-header-blocks, .drawer__footer')) {
      return;
    }
    inner.insertAdjacentHTML('afterbegin', emptyUiHtml());
  }

  function scheduleOrphanCheck(delay) {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshTimer = null;
      enforceDealIntegrity({ forceFetch: true });
    }, typeof delay === 'number' ? delay : 180);
  }

  function isBundleRemoveEvent(e) {
    var removeEl =
      e.target.closest &&
      e.target.closest('cart-remove-button, button.cart-remove-button, .cart-remove-button');
    if (!removeEl || !removeEl.closest('cart-drawer, cart-items, #CartDrawer')) return false;
    var row = removeEl.closest('.cart-item, [id*="CartDrawer-Item"], tr');
    return rowIsBundle(row);
  }

  function resolveTriggerItemFromEvent(e) {
    var row = e.target && e.target.closest && e.target.closest('.cart-item, [id*="CartDrawer-Item"], tr');
    if (!row || !lastCart || !lastCart.items) return null;
    var idAttr = row.id || '';
    var m = idAttr.match(/CartDrawer-Item-(\d+)/) || idAttr.match(/CartItem-(\d+)/);
    if (m) {
      var idx = Number(m[1]) - 1;
      if (lastCart.items[idx]) return lastCart.items[idx];
    }
    var keyEl = row.querySelector('[data-cart-item-key], [data-key]');
    var key = row.getAttribute('data-key') || (keyEl && (keyEl.getAttribute('data-cart-item-key') || keyEl.getAttribute('data-key')));
    if (key) {
      for (var i = 0; i < lastCart.items.length; i++) {
        if (lastCart.items[i].key === key) return lastCart.items[i];
      }
    }
    var vidEl = row.querySelector('[data-variant-id]');
    var vid = vidEl && Number(vidEl.getAttribute('data-variant-id'));
    if (vid) {
      for (var j = 0; j < lastCart.items.length; j++) {
        if (Number(lastCart.items[j].variant_id) === vid && isBundleLine(lastCart.items[j])) {
          return lastCart.items[j];
        }
      }
    }
    return bundleLines(lastCart)[0] || null;
  }

  function onBundleTrash(e) {
    if (!isBundleRemoveEvent(e)) return false;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var trigger = resolveTriggerItemFromEvent(e);
    removeOneDeal(trigger);
    return true;
  }

  function bindBundleTrash() {
    // pointerdown + click capture — beat theme CartRemoveButton every time
    document.addEventListener('pointerdown', onBundleTrash, true);
    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest && e.target.closest('.drawer__close, [data-hestia-cart-close]');
      if (closeBtn && closeBtn.closest('cart-drawer')) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
        return;
      }
      var overlay = e.target.closest && e.target.closest('#CartDrawer-Overlay, .cart-drawer__overlay');
      if (overlay) {
        e.preventDefault();
        closeDrawer();
        return;
      }
      onBundleTrash(e);
    }, true);

    document.addEventListener('keyup', function (e) {
      if (e.code === 'Escape') closeDrawer();
    });

    // If theme still calls updateQuantity(line, 0) on a HESTIA row, clear whole bundle
    function patchQty() {
      var nodes = document.querySelectorAll('cart-drawer-items, cart-items');
      nodes.forEach(function (el) {
        if (!el || el.__hestiaQtyPatched || typeof el.updateQuantity !== 'function') return;
        el.__hestiaQtyPatched = true;
        var orig = el.updateQuantity.bind(el);
        el.updateQuantity = function (line, quantity, event) {
          var row =
            document.getElementById('CartDrawer-Item-' + line) ||
            document.querySelector('[id="CartDrawer-Item-' + line + '"]') ||
            document.querySelector('#CartItem-' + line) ||
            (event && event.target && event.target.closest && event.target.closest('.cart-item'));
          if (rowIsBundle(row)) {
            var trigger = null;
            if (lastCart && lastCart.items) {
              var idMatch = ((row && row.id) || '').match(/(\d+)$/);
              if (idMatch) trigger = lastCart.items[Number(idMatch[1]) - 1] || null;
            }
            if (Number(quantity) === 0) {
              removeOneDeal(trigger);
              return;
            }
            if (trigger && isPrimaryLine(trigger) && Number(quantity) < (trigger.quantity || 1)) {
              var res = orig.apply(null, arguments);
              scheduleOrphanCheck(60);
              return res;
            }
          }
          var out = orig.apply(null, arguments);
          scheduleOrphanCheck(120);
          return out;
        };
      });
    }
    patchQty();
    setTimeout(patchQty, 500);
    setTimeout(patchQty, 1500);

    // React only to real open/close transitions. Reacting to every class write
    // (including our own) is what looped forever and froze the page.
    var d = getDrawer();
    var obsWasActive = !!(d && d.classList.contains('active'));
    var obs = new MutationObserver(function () {
      var dr = getDrawer();
      if (!dr) return;
      var isActive = dr.classList.contains('active');
      if (isActive && !obsWasActive) lockPageScroll();
      else if (!isActive && obsWasActive) unlockPageScroll();
      obsWasActive = isActive;
      patchQty();
    });
    if (d) obs.observe(d, { attributes: true, attributeFilter: ['class'] });
  }

  function isCartMutationUrl(urlStr) {
    return (
      urlStr.indexOf('/cart/add') !== -1 ||
      urlStr.indexOf('/cart/change') !== -1 ||
      urlStr.indexOf('/cart/update') !== -1 ||
      urlStr.indexOf('/cart/clear') !== -1
    );
  }

  function isOurRequest(args) {
    try {
      var opts = args[1] || {};
      var h = opts.headers;
      if (!h) return false;
      if (typeof h.get === 'function') return h.get('X-Hestia-Cart') === '1';
      return h['X-Hestia-Cart'] === '1' || h['x-hestia-cart'] === '1';
    } catch (e) {
      return false;
    }
  }

  function wrapFetch() {
    var orig = window.fetch;
    if (!orig || window.__hestiaFetchWrappedV6) return;
    window.__hestiaFetchWrappedV6 = true;
    window.__hestiaFetchWrappedV5 = true;
    window.__hestiaFetchWrapped = true;
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      var urlStr = String(url);
      var ours = isOurRequest(args);

      return orig.apply(this, args).then(function (res) {
        try {
          if (ours || !isCartMutationUrl(urlStr) || !res.ok) return res;

          if (urlStr.indexOf('/cart/add') !== -1) {
            openDrawer();
            res
              .clone()
              .json()
              .then(function (data) {
                if (data && data.items) {
                  // Normalize: add.js may return only added lines and omit item_count
                  lastCart =
                    data.item_count != null
                      ? data
                      : { items: data.items, item_count: data.items.length };
                  // Gift-only cart is invalid — try to attach selected stick, else force-purge gifts
                  if (cartIsGiftOnly(lastCart) || (primaryQty(lastCart) === 0 && giftLines(lastCart).length)) {
                    return recoverBundleOrPurge(lastCart);
                  }
                  // Prefer authoritative cart, then auto-complete powder or stick B1G3
                  return fetchCart().then(function (fresh) {
                    var cart = fresh || lastCart;
                    var chain = Promise.resolve(cart);
                    if (wantsPowderB1g3Bundle() || hairlineQty(cart) >= 1) {
                      chain = ensurePowderB1g3Bundle(cart);
                    } else if (!giftsAllowed(cart) && giftLines(cart).length) {
                      chain = removeOrphanGifts(cart, true);
                    }
                    return chain.then(function (mid) {
                      mid = mid || cart;
                      return ensureB1g3Bundle(mid).then(function (next) {
                        applyCartToUi(next || mid);
                        return next || mid;
                      });
                    });
                  });
                }
                scheduleOrphanCheck(80);
              })
              .catch(function () {});
            return res;
          }

          // Non-bundle change/update from theme — soft orphan check only
          if (!removingBundle) scheduleOrphanCheck(80);
        } catch (e) {}
        return res;
      });
    };
  }

  /** Block checkout when gift-only / deal-incomplete; always re-fetch (never trust stale lastCart). */
  function guardCheckout(e) {
    var t = e.target && e.target.closest && e.target.closest(
      'button[name="checkout"], [name="checkout"], .cart__checkout-button, #CartDrawer-Checkout, a[href="/checkout"], a[href*="/checkout"]'
    );
    if (!t) return;
    if (t.getAttribute && t.getAttribute('data-hestia-checkout-ok') === '1') {
      t.removeAttribute('data-hestia-checkout-ok');
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    // QA fix: this guard used to dead-end checkout — a failed /cart.js fetch, or a deal it
    // couldn't "complete", left the button disabled (or doing nothing) with no message.
    // It now always lets the shopper reach checkout; it only strips free gifts that are
    // not earned so they can't be checked out unpaid/at full price.
    function goCheckout() {
      setCheckoutBlocked(false);
      window.location.href = cartUrl('checkout');
    }
    function failOpen(c) {
      setCheckoutBlocked(false);
      if (!c || giftsAllowed(c) || !giftLines(c).length) return goCheckout();
      var updates = {};
      giftLines(c).forEach(function (g) { if (g && g.key) updates[g.key] = 0; });
      return postJson(cartUrl('cart/update.js'), { updates: updates })
        .then(goCheckout, goCheckout);
    }
    fetchCart(true).catch(function () { return null; }).then(function (cart) {
      if (!cart) return goCheckout();
      var proceed = function (ready) {
        setCheckoutBlocked(false);
        try {
          if (t.tagName === 'A' && t.getAttribute('href')) {
            window.location.href = t.getAttribute('href');
            return;
          }
          var form = t.closest && t.closest('form');
          if (form) {
            t.setAttribute('data-hestia-checkout-ok', '1');
            if (typeof form.requestSubmit === 'function') form.requestSubmit(t);
            else HTMLFormElement.prototype.submit.call(form);
            return;
          }
          window.location.href = '/checkout';
        } catch (err) {
          window.location.href = '/checkout';
        }
      };

      // Powder B1G3: finish 2 powders + gifts, then checkout (do not orphan-purge the deal).
      if (wantsPowderB1g3Bundle() || (hairlineQty(cart) >= 1 && giftLines(cart).length)) {
        var powderIncomplete = hairlineQty(cart) < 2 || missingGifts(cart).length > 0;
        if (!powderIncomplete && dealPrimarySatisfied(cart) && missingGifts(cart).length === 0) {
          return proceed(cart);
        }
        if (powderIncomplete && (wantsPowderB1g3Bundle() || (hairlineQty(cart) >= 1 && giftLines(cart).length))) {
          return ensurePowderB1g3Bundle(cart).then(function (next) {
            next = next || cart;
            // Cart changed under the drawer form — go straight to /checkout so the form's
            // stale updates[] can't overwrite the quantities we just added.
            if (dealPrimarySatisfied(next) && missingGifts(next).length === 0) {
              return goCheckout();
            }
            // Still incomplete after ensure — do NOT false-block Buy 1 / purge gifts if powder intent remains.
            return failOpen(next);
          });
        }
      }

      if (cartIsGiftOnly(cart) || (!giftsAllowed(cart) && giftLines(cart).length)) {
        // If powder B1G3 still selected, try complete instead of purge
        if (wantsPowderB1g3Bundle()) {
          return ensurePowderB1g3Bundle(cart).then(function (next) {
            if (dealPrimarySatisfied(next) && missingGifts(next).length === 0) return goCheckout();
            return failOpen(next);
          });
        }
        return failOpen(cart);
      }
      if (hestiaQty(cart) > 0 && wantsB1g3Bundle()) {
        var incomplete = hestiaQty(cart) < 2 || missingGifts(cart).length > 0;
        if (incomplete) {
          return ensureB1g3Bundle(cart).then(function (next) {
            return dealPrimarySatisfied(next || cart) ? goCheckout() : failOpen(next || cart);
          }, function () { return failOpen(cart); });
        }
      }
      setCheckoutBlocked(false);
      try {
        if (t.tagName === 'A' && t.getAttribute('href')) {
          window.location.href = t.getAttribute('href');
          return;
        }
        var form = t.closest && t.closest('form');
        if (form) {
          t.setAttribute('data-hestia-checkout-ok', '1');
          if (typeof form.requestSubmit === 'function') form.requestSubmit(t);
          else HTMLFormElement.prototype.submit.call(form);
          return;
        }
        window.location.href = '/checkout';
      } catch (err) {
        window.location.href = '/checkout';
      }
    }).catch(function () { goCheckout(); });
  }


  function bindCheckoutGuard() {
    if (window.__hestiaCheckoutGuardV2) return;
    window.__hestiaCheckoutGuardV2 = true;
    window.__hestiaCheckoutGuard = true;
    document.addEventListener('click', guardCheckout, true);
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.querySelector || !form.querySelector('[name="checkout"]')) return;
      if (form.getAttribute && form.getAttribute('data-hestia-checkout-ok') === '1') {
        form.removeAttribute('data-hestia-checkout-ok');
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      fetchCart(true).then(function (cart) {
        var go = function () {
          setCheckoutBlocked(false);
          try {
            form.setAttribute('data-hestia-checkout-ok', '1');
            HTMLFormElement.prototype.submit.call(form);
          } catch (err) {
            window.location.href = '/checkout';
          }
        };

        // Mirror click guard: complete powder B1G3 instead of false gift-only purge.
        if (wantsPowderB1g3Bundle() || (hairlineQty(cart) >= 1 && giftLines(cart).length)) {
          var powderIncomplete = hairlineQty(cart) < 2 || missingGifts(cart).length > 0;
          if (!powderIncomplete && dealPrimarySatisfied(cart)) return go();
          if (powderIncomplete) {
            return ensurePowderB1g3Bundle(cart).then(function (next) {
              next = next || cart;
              if (dealPrimarySatisfied(next) && missingGifts(next).length === 0) return go();
              if (wantsPowderB1g3Bundle()) {
                setCheckoutBlocked(true);
                openDrawer();
                return;
              }
              return removeOrphanGifts(next, true).then(function () { openDrawer(); });
            });
          }
        }

        if (cartIsGiftOnly(cart) || (!giftsAllowed(cart) && giftLines(cart).length)) {
          if (wantsPowderB1g3Bundle()) {
            return ensurePowderB1g3Bundle(cart).then(function (next) {
              if (dealPrimarySatisfied(next) && missingGifts(next).length === 0) return go();
              setCheckoutBlocked(true);
              openDrawer();
            });
          }
          setCheckoutBlocked(true);
          return removeOrphanGifts(cart, true).then(function () { openDrawer(); });
        }
        go();
      });
    }, true);
  }


  function injectEmptyStackFixCss() {
    if (document.getElementById('hestia-empty-stack-fix')) return;
    var style = document.createElement('style');
    style.id = 'hestia-empty-stack-fix';
    style.textContent =
      'cart-drawer:not(.is-empty) .hestia-cart-empty,' +
      'cart-drawer:not(.is-empty) [data-hestia-cart-empty],' +
      'cart-drawer:not(.is-empty) .drawer__inner > .hestia-cart-empty{' +
      'display:none!important;visibility:hidden!important;height:0!important;min-height:0!important;overflow:hidden!important;pointer-events:none!important;}' +
      'cart-drawer:not(.is-empty) .drawer__inner{' +
      'display:flex!important;flex-direction:column!important;height:100%!important;max-height:100%!important;min-height:0!important;overflow:hidden!important;}' +
      'cart-drawer:not(.is-empty) .drawer__inner > *:has(cart-drawer-items){' +
      'flex:1 1 0%!important;min-height:0!important;overflow:hidden!important;display:flex!important;flex-direction:column!important;}' +
      'cart-drawer:not(.is-empty) cart-drawer-items{' +
      'display:flex!important;flex-direction:column!important;flex:1 1 0%!important;min-height:0!important;' +
      'overflow-x:hidden!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;' +
      'overscroll-behavior:contain!important;touch-action:pan-y!important;}' +
      'cart-drawer:not(.is-empty) cart-drawer-items .cart-drawer__form,' +
      'cart-drawer:not(.is-empty) cart-drawer-items .scrollable-contents{' +
      'flex:1 1 auto!important;min-height:0!important;flex-wrap:nowrap!important;width:100%!important;}' +
      'cart-drawer:not(.is-empty) .drawer__footer{display:block!important;flex-shrink:0!important;}' +
      'html.hestia-cart-open,html.hestia-scroll-locked,html:has(cart-drawer.active){' +
      'overflow:hidden!important;overscroll-behavior:none!important;height:100%!important;}' +
      'body.hestia-cart-open,body:has(cart-drawer.active){' +
      'overflow:hidden!important;overscroll-behavior:none!important;width:100%!important;touch-action:none;}' +
      'body.hestia-scroll-locked-fixed{position:fixed!important;left:0!important;right:0!important;width:100%!important;}' +
      'cart-drawer.active,cart-drawer.active cart-drawer-items{touch-action:pan-y!important;}' +'cart-drawer:not(.active):not(.animate),cart-drawer:not(.active):not(.animate) *{pointer-events:none!important;}' +'cart-drawer:not(.active):not(.animate),cart-drawer.drawer:not(.active):not(.animate){visibility:hidden!important;}' +'cart-drawer.animate:not(.active){visibility:visible!important;pointer-events:none!important;}' +'cart-drawer.animate:not(.active) *{pointer-events:none!important;}' +'cart-drawer.active,cart-drawer.drawer.active{visibility:visible!important;pointer-events:auto!important;}' +'cart-drawer:not(.active) .cart-drawer__overlay,cart-drawer:not(.active) #CartDrawer-Overlay{pointer-events:none!important;visibility:hidden!important;}';
    document.head.appendChild(style);
  }

  function wrapXHR() {
    if (window.__hestiaXhrWrappedV1 || !window.XMLHttpRequest) return;
    window.__hestiaXhrWrappedV1 = true;
    var Orig = window.XMLHttpRequest;
    function WrappedXHR() {
      var xhr = new Orig();
      var open = xhr.open;
      xhr.open = function (method, url) {
        try { xhr.__hestiaUrl = String(url || ''); } catch (e) { xhr.__hestiaUrl = ''; }
        return open.apply(xhr, arguments);
      };
      xhr.addEventListener('load', function () {
        try {
          var u = xhr.__hestiaUrl || '';
          if (u && isCartMutationUrl(u)) scheduleOrphanCheck(80);
        } catch (e) {}
      });
      return xhr;
    }
    WrappedXHR.prototype = Orig.prototype;
    window.XMLHttpRequest = WrappedXHR;
  }

  function init() {
    injectEmptyStackFixCss();
    document.addEventListener('cart-drawer:open', function () {
      lockPageScroll();
      scheduleOrphanCheck(50);
    });
    document.addEventListener('cart-drawer:close', function () { unlockPageScroll(); });
    wrapFetch();
    wrapXHR();
    bindBundleTrash();
    bindCheckoutGuard();
    bindDrawerGhostObserver();
    ensureInteractiveIfDrawerClosed();
    window.addEventListener('pageshow', function () {
      ensureInteractiveIfDrawerClosed();
      enforceDealIntegrity({ forceFetch: true });
    });
    window.addEventListener('load', ensureInteractiveIfDrawerClosed);
    setInterval(ensureInteractiveIfDrawerClosed, 1500);
    setInterval(function () {
      var d = getDrawer();
      if (!d || !d.classList.contains('active')) return;
      if (removingBundle) return;
      enforceDealIntegrity({ forceFetch: true });
    }, 2500);
    enforceDealIntegrity({ forceFetch: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
